import { CloseButton, Tabs, Text } from "@mantine/core";
import { useState } from "react";

import type { AdCopy, Job } from "../../../api/generated/model";
import classes from "./ad-copies.module.css";
import { GenerateCopy } from "./GenerateCopy";
import { WriteCopy } from "./WriteCopy";

export interface CreateCopyProps {
  teamId: string;
  brandId: string;
  onClose: () => void;
  /** AI Generate started: its job drafted the copy. */
  onStarted: (job: Job) => void;
  /** Write saved the copy. */
  onSaved: (copy: AdCopy) => void;
}

/**
 * The Ad copy tab's "Create Ad copy" (live's `create-text-copies`, captures advanced-234/05 to
 * 07): its x, and "AI Generate" (chosen at first, its button "Generate Copy") and "Write", both
 * starting empty, with no product or inspiration.
 */
export function CreateCopy({ teamId, brandId, onClose, onStarted, onSaved }: CreateCopyProps) {
  const [tab, setTab] = useState<"generate" | "write">("generate");
  return (
    <div className={classes.tabCard}>
      <div className={classes.groupHeader}>
        <Text className={classes.listTitle}>Create Ad copy</Text>
        <CloseButton aria-label="Close" onClick={onClose} />
      </div>
      <Tabs
        value={tab}
        onChange={(next) => (next === "generate" || next === "write" ? setTab(next) : undefined)}
        keepMounted={false}
        className={classes.tabs}
      >
        <Tabs.List>
          <Tabs.Tab value="generate">AI Generate</Tabs.Tab>
          <Tabs.Tab value="write">Write</Tabs.Tab>
        </Tabs.List>
        <Tabs.Panel value="generate" className={classes.panel}>
          <GenerateCopy
            teamId={teamId}
            brandId={brandId}
            product={null}
            inspiration={null}
            label="Generate Copy"
            onStarted={onStarted}
          />
        </Tabs.Panel>
        <Tabs.Panel value="write" className={classes.panel}>
          <WriteCopy teamId={teamId} brandId={brandId} product={null} onSaved={onSaved} />
        </Tabs.Panel>
      </Tabs>
    </div>
  );
}
